import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'

const itemDefault = () => ({
  id: '',
  operadoraCnpj: '',
  hospitalId: null,
  codigoHis: '',
  sourceHisReferencia: '',
  classificacaoNome: '',
  classificacaoCodigoHis: '',
})

const filtrosDefault = () => ({
  descricao: '',
  codigoHis: '',
  hospitalId: null,
  periodoCriacaoInicio: null,
  periodoCriacaoFim: null,
})

@Module({ namespaced: true, name: 'OperadoraHospitalStore' })
export default class OperadoraHospitalStore extends VuexModule {
  lista: any[] = []
  total: number = 0
  pagina: number = 1
  qtdPorPagina: number = 20
  filtros: any = filtrosDefault()
  item: any = itemDefault()
  modalCriarEditar: boolean = false
  hospitais: any[] = []

  @Mutation
  setLista(value: any[]) { this.lista = value }

  @Mutation
  setTotal(value: number) { this.total = value }

  @Mutation
  setPagina(value: number) { this.pagina = value }

  @Mutation
  limparFiltros() {
    this.filtros = filtrosDefault()
    this.pagina = 1
  }

  @Mutation
  setItem(value: any) { this.item = { ...value } }

  @Mutation
  limparItem() { this.item = itemDefault() }

  @Mutation
  setModalCriarEditar(value: boolean) { this.modalCriarEditar = value }

  @Mutation
  setHospitais(value: any[]) { this.hospitais = value }

  @Action
  async carregarHospitais() {
    const request = await RemuneracaoMedicaApi.getFontePagadoraAll()
    if (request.success) this.context.commit('setHospitais', request.data || [])
  }

  @Action
  async getAll() {
    try {
      const params = { ...this.filtros, pagina: this.pagina, qtdPorPagina: this.qtdPorPagina }
      const request = await RemuneracaoMedicaApi.getOperadoraHospitalListagem(params)
      if (request.success) {
        this.context.commit('setLista', request.data.itens || [])
        this.context.commit('setTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar as operadoras x hospital.' }
    }
  }

  @Action
  async salvar() {
    try {
      const params = {
        id: this.item.id || null,
        operadoraCnpj: (this.item.operadoraCnpj || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase(),
        hospitalId: this.item.hospitalId,
        codigoHis: this.item.codigoHis,
        sourceHisReferencia: this.item.sourceHisReferencia,
        classificacaoNome: this.item.classificacaoNome,
        classificacaoCodigoHis: this.item.classificacaoCodigoHis,
      }
      return await RemuneracaoMedicaApi.upsertOperadoraHospital(params)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o mapeamento operadora.' }
    }
  }

  @Action
  async remover(id: string) {
    try {
      return await RemuneracaoMedicaApi.removeOperadoraHospital(id)
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao excluir o mapeamento operadora.' }
    }
  }
}
